const copyText = (target: HTMLInputElement): HTMLInputElement | null => {
  const range = document.createRange();

  target.select();
  range.selectNodeContents(target);

  const sel = window.getSelection();

  if (!sel) {
    return null;
  }

  sel.removeAllRanges();
  sel.addRange(range);

  target.setSelectionRange(0, target.value.length);
  document.execCommand('copy');

  return target;
};

export default copyText;
